export const PROJECTION_CHECKIN_OPTIONS = Object.freeze([
  Object.freeze({ score: 5, value: 'strong', label: 'Strong', compactLabel: 'Strong', description: 'A banger — projecting hard, people notice.' }),
  Object.freeze({ score: 4, value: 'projecting above average', label: 'Projecting above average', compactLabel: 'Above average', description: 'Still performing well' }),
  Object.freeze({ score: 3, value: 'projecting as expected', label: 'Projecting as expected', compactLabel: 'As expected', description: 'Settled' }),
  Object.freeze({ score: 2, value: 'skin scent', label: 'Skin scent', compactLabel: 'Skin scent', description: 'On the skin, not projecting' }),
  Object.freeze({ score: 1, value: 'gone', label: 'Gone', compactLabel: 'Gone', description: 'Cannot smell it' }),
])

export function projectionCheckin(value, at = new Date()) {
  const option = PROJECTION_CHECKIN_OPTIONS.find(candidate => candidate.value === value || candidate.score === Number(value))
  if (!option) throw new Error('Projection check-in must be a value from 1 to 5.')
  const timestamp = at instanceof Date ? at.toISOString() : new Date(at).toISOString()
  return { at: timestamp, value: option.value }
}

export function appendProjectionCheckin(existing, value, at = new Date()) {
  return [...(Array.isArray(existing) ? existing : []), projectionCheckin(value, at)]
}
